import React from "react";
import API from "@unisearch/helpers/api";
import {
  MentorHero,
  MentorListGrid,
  MentorConnect,
  MentorJoin,
} from "@modules/study/mentor";

import TestimonialSection from "@modules/study/common/sections/testimonial/testimonial";
import { LayoutMain } from "@unisearch/theme/layout";
import PartnerGrid from "@modules/study/common/sections/partner_grid";

const Mentor = ({ mentorList }) => {
  return (
    <LayoutMain
      title="Mentor"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/mentors`}
    >
      <MentorHero />
      {mentorList?.length > 0 && <MentorListGrid mentorList={mentorList} />}
      <MentorConnect />
      <PartnerGrid />
      <TestimonialSection />
      <MentorJoin />
    </LayoutMain>
  );
};

export default Mentor;

export async function getServerSideProps() {
  let props = {
    mentorList: [],
  };

  try {
    await API.get(`/public/user-mentor`).then((resp) => {
      if (!resp.error && resp.data) {
        props.mentorList = resp.data;
      }
    });

    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
